import { render } from "./PatientRecord.vue?vue&type=template&id=a4d2f5cc"
import script from "./PatientRecord.vue?vue&type=script&lang=js"
export * from "./PatientRecord.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__